<!-- En-tête page -->
<div class="page-title">
  <h2>Flights</h2>
  <button mat-mini-fab class="fab-compact add-btn" routerLink="/flight" aria-label="Create quickly">
    <mat-icon fontSet="material-symbols-outlined">add</mat-icon>
  </button>
</div>

<!-- Filtres -->
<form [formGroup]="filters" (ngSubmit)="applyFilters()" class="filters-container" novalidate>
  <div class="filters-row">
    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Start date</mat-label>
      <input matInput [matDatepicker]="dpStart" formControlName="startDate" />
      <mat-datepicker-toggle matSuffix [for]="dpStart"></mat-datepicker-toggle>
      <mat-datepicker #dpStart></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>End date</mat-label>
      <input matInput [matDatepicker]="dpEnd" formControlName="endDate" />
      <mat-datepicker-toggle matSuffix [for]="dpEnd"></mat-datepicker-toggle>
      <mat-datepicker #dpEnd></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="ff-compact">
      <mat-label>Aircrafts</mat-label>
      <mat-select formControlName="aircraftCodes" multiple>
        <mat-option *ngFor="let a of aircraftOptions" [value]="a.code">
          {{ a.code }} <span *ngIf="a.name">— {{ a.name }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="filters-actions actions">
      <button mat-mini-fab type="button" color="primary" (click)="setToday()" aria-label="Today">
        <mat-icon>today</mat-icon>
      </button>
      <button mat-mini-fab color="primary" type="submit" aria-label="Search">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-icon-button type="button" (click)="resetFilters()" aria-label="Reset filters">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>
</form>

<!-- Table -->
<div class="table-container">
  <table mat-table [dataSource]="dataSource" [multiTemplateDataRows]="true" matSort matSortDisableClear class="flight-table" role="table">
    <!-- Chevron -->
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="Afficher les détails"></th>
      <td mat-cell *matCellDef="let row" class="cell-expand">
        <button
          mat-icon-button
          class="expander-btn"
          (click)="toggleRow(row)"
          [attr.aria-expanded]="isExpanded(row)"
          [attr.aria-controls]="'detail-' + row.id"
          [@chev]="isExpanded(row) ? 'expanded' : 'collapsed'"
          aria-label="Basculer détails"
        >
          <mat-icon class="expander-icon">chevron_right</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Code -->
    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
      <td mat-cell *matCellDef="let row">
        <span>{{ row.aircraft.code }}</span>
        <span class="base" *ngIf="row.base">&nbsp;• {{ row.base }}</span>
      </td>
    </ng-container>

    <!-- Date -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
      <td mat-cell *matCellDef="let row">
        {{ row.date | date : 'dd/MM/yyyy' }}
      </td>
    </ng-container>

    <!-- Crew -->
    <ng-container matColumnDef="crew">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Crew</th>
      <td mat-cell *matCellDef="let row">
        <span *ngIf="row.pilot">{{ row.pilot.lastname }}</span>
        <span *ngIf="row.instructor"> / {{ row.instructor.lastname }}</span>
      </td>
    </ng-container>

    <!-- Takeoff -->
    <ng-container matColumnDef="takeoff">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Takeoff</th>
      <td mat-cell *matCellDef="let row">
        <span class="mono">{{ row.origin }}</span>
        {{ row.takeoff | date : 'HH:mm' }}
        <span class="base" *ngIf="row.base">&nbsp;• {{ row.base }}</span>
      </td>
    </ng-container>

    <!-- Landing -->
    <ng-container matColumnDef="landing">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Landing</th>
      <td mat-cell *matCellDef="let row">
        <span class="mono">{{ row.destination }}</span>
        {{ row.landing | date : 'HH:mm' }}
        <span class="base" *ngIf="row.base">&nbsp;• {{ row.base }}</span>
      </td>
    </ng-container>

    <!-- Landings number -->
    <ng-container matColumnDef="ldg">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Ldg</th>
      <td mat-cell *matCellDef="let row">
        <span class="mono">{{ computeLandingsNumber(row.landings) }}</span>
        <span class="base" *ngIf="row.base">&nbsp;• {{ row.base }}</span>
      </td>
    </ng-container>

    <!-- Counter 1 -->
    <ng-container matColumnDef="counterBegin">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Start</th>
      <td mat-cell *matCellDef="let row">
        <span class="mono">{{ formatMinutesToHours(row.counterBeginMinutes) }}</span>
        <span class="base" *ngIf="row.base">&nbsp;• {{ row.base }}</span>
      </td>
    </ng-container>

    <!-- Counter 2 -->
    <ng-container matColumnDef="counterEnd">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>End</th>
      <td mat-cell *matCellDef="let row">
        <span class="mono">{{ formatMinutesToHours(row.counterEndMinutes) }}</span>
        <span class="base" *ngIf="row.base">&nbsp;• {{ row.base }}</span>
      </td>
    </ng-container>

    <!-- Air time -->
    <ng-container matColumnDef="airtime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Air</th>
      <td mat-cell *matCellDef="let row">
        <span class="mono">{{ formatMinutesToHours(row.counterEndMinutes - row.counterBeginMinutes) }}</span>
        <span class="base" *ngIf="row.base">&nbsp;• {{ row.base }}</span>
      </td>
    </ng-container>

    <!-- Block time -->
    <ng-container matColumnDef="blocktime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Block</th>
      <td mat-cell *matCellDef="let row">
        <span class="mono">{{ formatMinutesToHours(diffMinutes(row.blockOn, row.blockOff)) }}</span>
        <span class="base" *ngIf="row.base">&nbsp;• {{ row.base }}</span>
      </td>
    </ng-container>

    <!-- Pricing -->
    <ng-container matColumnDef="pricing">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Pricing</th>
      <td mat-cell *matCellDef="let row">
        <span class="mono">{{ row.priceCategory }}</span>
        <span class="base" *ngIf="row.base">&nbsp;• {{ row.base }}</span>
      </td>
    </ng-container>

    <!-- En-tête -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></tr>

    <!-- Lignes principales -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns; trackBy: trackById" class="data-row" role="row"></tr>

    <!-- Colonne 'detail' (ligne étendue) -->
    <ng-container matColumnDef="detail">
      <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length" class="detail-cell">
        <!-- En-tête du détail -->
        <div class="detail-header">
          <div class="detail-title">
            <mat-icon fontSet="material-symbols-outlined" class="title-icon">flight</mat-icon>
            <div class="title-stack">
              <h4 class="aircraft-title">{{ row.aircraft.code }}</h4>
              <div class="sub">
                <span class="mono">{{ row.origin }}</span> → <span class="mono">{{ row.destination }}</span> •
                {{ row.date | date : 'EEE d MMM, HH:mm' : '' : 'en-US' }}
              </div>
            </div>
          </div>

          <div class="detail-chips" role="list" aria-label="Statuts">
            <mat-chip-set>
              <mat-chip class="chip-airworthy" role="listitem">OK</mat-chip>
              <mat-chip class="chip-findings" role="listitem" *ngIf="row.findings?.length">Findings</mat-chip>
            </mat-chip-set>
          </div>
        </div>

        <!-- Carte de détail -->
        <div class="detail-card" [id]="'detail-' + row.id" [@detailRow]>
          <!-- Métriques -->
          <aside class="metrics" aria-label="Métriques">
            <div class="metric">
              <div class="label">Crew</div>
              <div class="value">
                <span *ngIf="row.pilot">{{ row.pilot.lastname }}</span>
                <span *ngIf="row.instructor"> / {{ row.instructor.lastname }}</span>
              </div>
            </div>
            <div class="metric">
              <div class="label">Origin / Destination</div>
              <div class="value">
                <span class="mono">{{ row.origin }}</span> • {{ row.takeoff | date : 'HH:mm' }}<br />
                <span class="mono">{{ row.destination }}</span> •
                {{ row.landing | date : 'HH:mm' }}
              </div>
            </div>
            <div class="metric">
              <div class="label">Counter start</div>
              <div class="value">{{ formatMinutesToHours(row.counterBeginMinutes) }}<br /></div>
            </div>
            <div class="metric">
              <div class="label">Counter end</div>
              <div class="value">
                {{ formatMinutesToHours(row.counterEndMinutes) }}
              </div>
            </div>
            <div class="metric">
              <div class="label">Air time</div>
              <div class="value">
                {{ formatMinutesToHours(row.counterEndMinutes - row.counterBeginMinutes) }}
              </div>
            </div>
            <div class="metric">
              <div class="label">Block time</div>
              <div class="value">
                {{ formatMinutesToHours(diffMinutes(row.blockOn, row.blockOff)) }}
              </div>
            </div>
            <div class="metric">
              <div class="label">Pricing</div>
              <div class="value">{{ row.priceCategory }}</div>
            </div>
            <div class="metric">
              <div class="label">MOU(A)</div>
              <div class="value">{{ row.moua }}</div>
            </div>
            <div class="metric">
              <div class="label">Landing(s)</div>
              <div class="value">{{ computeLandingsNumber(row.landings) }}</div>
            </div>
            <div class="metric">
              <div class="label">Passengers</div>
              <div class="value">{{ row.passengers }}</div>
            </div>
            <div class="metric">
              <div class="label">Fuel refilled</div>
              <div class="value">{{ row.fuelRefilled ?? 0 }} L</div>
            </div>
            <div class="metric">
              <div class="label">Oil refilled</div>
              <div class="value">{{ row.oilRefilled ?? 0 }} L</div>
            </div>
            <div class="metric">
              <div class="label">Current hours</div>
              <div class="value">
                {{ formatMinutesToHours(row.aircraft.currentCounterMinutes ?? row.counterMinutes) }}
                h
              </div>
            </div>
            <div class="metric">
              <div class="label">Next maintenance</div>
              <div class="value">
                {{ formatMinutesToHours(row.aircraft.nextMaintenanceMinutes) ?? '—' }}
                h
              </div>
            </div>
          </aside>
        </div>
      </td>
    </ng-container>

    <!-- Ligne détail (rendue seulement quand ouverte) -->
    <tr mat-row *matRowDef="let row; columns: ['detail']; when: isDetailRow" class="detail-row"></tr>

    <!-- État vide -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <span style="padding: 1rem">No flight</span>
      </td>
    </tr>
  </table>

  <mat-paginator [length]="total" [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
</div>
